import { Utils } from 'formiojs';
import { form as template } from 'src/formio/templates/datagrid/form';

const compiledForm = Utils.Evaluator.template(template, 'datagrid');
export const formioDatagridComponentCustomTemplate = (ctx: any) => {
    return compiledForm(ctx);
};
